import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";

const cookies = new Cookies();

const S = {
  // ============================================================
  //  لغة التصميم — إعادة تصميم كاملة
  //  خلفية هادئة، هيدر متدرّج، بطاقات ناعمة الظل، تبويب مقسّم،
  //  وجداول برأس رمادي فاتح وحوم صفّي (عبر CSS المحقون stCss).
  //  كل المفاتيح القديمة محفوظة كي لا يُمسّ منطق الأقسام.
  // ============================================================
  page: { padding: "26px 24px 40px", direction: "rtl", background: "#f1f5f9", minHeight: "100vh", fontFamily: "'Segoe UI', Tahoma, sans-serif" },
  pageInner: { paddingInline: "max(24px, calc((100% - 1180px) / 2))", boxSizing: "border-box" },

  // ===== الهيدر البطولي =====
  hero: {
    background: "linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 55%, #2563eb 100%)",
    borderRadius: 20, padding: "24px 26px", color: "#fff", marginBottom: 18,
    boxShadow: "0 10px 30px rgba(29,78,216,.25)",
    display: "flex", flexWrap: "wrap", gap: 18, alignItems: "center",
  },
  heroTitle: { fontSize: 23, fontWeight: 800, margin: 0, letterSpacing: ".2px" },
  heroSub: { fontSize: 13, opacity: .85, margin: "5px 0 0", maxWidth: 520, lineHeight: 1.7 },
  heroStats: { display: "flex", gap: 12, marginInlineStart: "auto", flexWrap: "wrap" },
  heroStat: {
    background: "rgba(255,255,255,.13)", border: "1px solid rgba(255,255,255,.22)",
    borderRadius: 14, padding: "10px 18px", minWidth: 118, textAlign: "center",
    backdropFilter: "blur(4px)",
  },
  heroStatLabel: { fontSize: 11.5, opacity: .8, fontWeight: 600, marginBottom: 3 },
  heroStatValue: { fontSize: 21, fontWeight: 800 },

  h1: { fontSize: 24, fontWeight: 800, color: "#0f172a", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "#64748b", margin: "0 0 20px" },

  card: { background: "#fff", borderRadius: 18, boxShadow: "0 2px 10px rgba(15,23,42,.05)", border: "1px solid #e8eef5", marginBottom: 16, overflow: "hidden" },
  pad: { padding: 20 },

  input: { padding: "12px 15px", borderRadius: 12, border: "1.5px solid #e2e8f0", fontSize: 15, outline: "none", fontFamily: "inherit", background: "#fff", transition: "border-color .15s, box-shadow .15s" },
  btnPrimary: { padding: "12px 26px", borderRadius: 12, border: "none", background: "linear-gradient(135deg,#2563eb,#1d4ed8)", color: "#fff", fontWeight: 800, cursor: "pointer", fontSize: 15, boxShadow: "0 4px 12px rgba(37,99,235,.3)" },
  btnOk: { padding: "11px 22px", borderRadius: 11, border: "none", background: "linear-gradient(135deg,#16a34a,#15803d)", color: "#fff", fontWeight: 800, cursor: "pointer", fontSize: 14, boxShadow: "0 4px 10px rgba(22,163,74,.25)" },
  btnGhost: { padding: "9px 16px", borderRadius: 10, border: "1px solid #dbe3ec", background: "#fff", color: "#334155", fontWeight: 700, cursor: "pointer", fontSize: 13 },
  btnDanger: { padding: "6px 14px", borderRadius: 9, border: "1px solid #fecaca", background: "#fff5f5", color: "#dc2626", fontWeight: 800, cursor: "pointer", fontSize: 12.5 },

  th: { textAlign: "right", padding: "12px 14px", fontSize: 11.5, color: "#475569", fontWeight: 800, background: "#f8fafc", borderBottom: "1px solid #e8eef5", whiteSpace: "nowrap" },
  td: { textAlign: "right", padding: "13px 14px", fontSize: 13.5, color: "#0f172a", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" },
  table: { width: "100%", borderCollapse: "collapse" },

  stat: { flex: 1, minWidth: 150, padding: "16px 18px", background: "#fff", borderRadius: 16, border: "1px solid #e8eef5", boxShadow: "0 2px 8px rgba(15,23,42,.04)" },
  statLabel: { fontSize: 12, color: "#64748b", fontWeight: 700, marginBottom: 5 },
  statValue: { fontSize: 24, fontWeight: 800, color: "#0f172a" },

  chip: { display: "inline-block", padding: "2.5px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: "#eff6ff", color: "#2563eb", border: "1px solid #dbeafe", marginInlineEnd: 4, marginBottom: 3 },
  empty: { padding: 54, textAlign: "center", color: "#94a3b8", fontSize: 15 },

  warnBox: { padding: "13px 16px", borderRadius: 12, background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },
  okBox: { padding: "13px 16px", borderRadius: 12, background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#166534", fontSize: 13.5, marginBottom: 14, fontWeight: 600 },

  // ===== السبنر =====
  spinWrap: { display: "flex", alignItems: "center", justifyContent: "center", gap: 12, padding: 60, color: "#64748b", fontSize: 14 },
  spinner: { width: 34, height: 34, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: "#2563eb", animation: "stSpin .8s linear infinite" },

  // ===== التصفيح =====
  pager: { display: "flex", gap: 6, alignItems: "center", justifyContent: "center", flexWrap: "wrap", padding: "16px 0 14px" },
  pBtn: (off) => ({ minWidth: 36, height: 34, padding: "0 12px", borderRadius: 10, border: "1px solid #dbe3ec", background: "#fff", color: off ? "#cbd5e1" : "#334155", fontWeight: 800, fontSize: 13, cursor: off ? "default" : "pointer" }),
  pInfo: { fontSize: 13, color: "#64748b", padding: "0 8px", fontWeight: 800 },

  badge: (bg, color) => ({ display: "inline-block", padding: "3px 12px", borderRadius: 20, fontSize: 12, fontWeight: 800, background: bg, color }),
  sumCard: { padding: "13px 16px", background: "#f8fafc", borderRadius: 13, border: "1px solid #e8eef5", minWidth: 190 },

  // ===== التبويب المقسّم =====
  tabs: {
    display: "flex", gap: 4, marginBottom: 18, flexWrap: "wrap",
    background: "#fff", border: "1px solid #e8eef5", borderRadius: 15,
    padding: 5, boxShadow: "0 2px 8px rgba(15,23,42,.04)",
  },
  tab: (on) => ({
    padding: "10px 18px", borderRadius: 11, cursor: "pointer", fontSize: 13.5, fontWeight: 800,
    background: on ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "transparent",
    color: on ? "#fff" : "#475569",
    boxShadow: on ? "0 3px 10px rgba(37,99,235,.3)" : "none",
    transition: "all .15s", userSelect: "none",
  }),
};

// CSS المحقون: ما لا تبلغه الأنماط الداخلية (hover · focus)
const stCss = `
  @keyframes stSpin { to { transform: rotate(360deg); } }
  .st-table tbody tr:hover td { background: #f8fafc; }
  .st-scan:focus { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37,99,235,.14); }
  .st-btn:hover { filter: brightness(1.05); }
`;


const fmt = (n) => {
  const v = Number(n) || 0;
  return v % 1 === 0 ? v.toLocaleString("en-US")
    : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default class StockTransfer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,          // { list, devices, summary, grandTotal }
      lists: [],
      loading: true,
      scanValue: "",
      working: false,
      viewingId: null,     // قائمة مؤرشفة معروضة
      tab: "list",         // list | pending | returned
      pending: null,       // أجهزة تنتظر موافقة القفل
      returned: null,      // أجهزة رجعت من لوحة التحكم
      stats: null,         // تفاصيل العدّادات (ممسوحة/غير ممسوحة/مسحوبة)
      pendingMac: null,    // طافيات تنتظر ربط الماك (الهوية)
      verify: null,        // لوحة تدقيق الإدخال
      verifyScan: "",      // حقل مسح الباركود للتدقيق
      lastVerified: null,  // آخر جهاز مُدقَّق (للمراجعة البصرية)
      // ===== سجل القوائم =====
      archive: null,       // { rows, total, page, pages }
      archiveLoading: false,
      archView: null,      // القائمة المستعرَضة { list, devices, count, grandTotal, page, pages }
      archViewLoading: false,
    };
    this.scanRef = React.createRef();
    this.verifyRef = React.createRef();
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }

  componentDidMount() {
    this.loadList();
    this.loadLists();
    this.loadStats();
  }

  loadStats = () => {
    axios.get(host + 'repair/counters/detail', { headers: this.header() })
      .then(res => this.setState({ stats: (res.data && res.data.data) || null }))
      .catch(() => { });
  };

  // الطافيات التي أُدخلت بالسيريال وتنتظر ربط wifi_mac (الهوية الفريدة)
  loadPendingMac = () => {
    axios.get(host + 'purchase/pending-mac', { headers: this.header() })
      .then(res => this.setState({ pendingMac: (res.data && res.data.data) || null }))
      .catch(() => toast.error("تعذّر تحميل الأجهزة بانتظار الماك"));
  };

  // ===== تدقيق الإدخال =====
  // origin=sections: هذه الصفحة تدقّق ما خرج من الأقسام (صيانة/سوفت/
  // غير معرّف) فقط — الإدخالات الجديدة تُدقَّق في شاشة قوائم الشراء
  loadVerify = () => {
    axios.get(host + 'purchase/verify/board?origin=sections', { headers: this.header() })
      .then(res => this.setState({ verify: (res.data && res.data.data) || null }))
      .catch(() => toast.error("تعذّر تحميل لوحة التدقيق"));
  };

  // المسح لا يغيّر العدد — غرضه التحقق من وجود الجهاز وحالته
  doVerifyScan = () => {
    const code = (this.state.verifyScan || "").trim();
    if (!code) return;

    this.setState({ working: true });
    axios.post(host + 'purchase/verify/scan', { code, token: cookies.get("token") },
      { headers: this.header() })
      .then(res => {
        const d = res.data && res.data.data;
        this.setState({ working: false, verifyScan: "", lastVerified: d ? d.device : null });
        toast.success((d && d.msg) || "تم التدقيق");
        this.loadVerify();
        if (this.verifyRef.current) this.verifyRef.current.focus();
      })
      .catch(err => {
        this.setState({ working: false });
        const m = err.response && err.response.data && err.response.data.message;
        toast.error(m || "تعذّر تدقيق الجهاز");
        if (this.verifyRef.current) this.verifyRef.current.select();
      });
  };

  loadPending = () => {
    axios.get(host + 'repair/stock/pending', { headers: this.header() })
      .then(res => this.setState({ pending: (res.data && res.data.data) || null }))
      .catch(() => toast.error("تعذّر تحميل الأجهزة الجاهزة"));
  };

  loadReturned = () => {
    axios.get(host + 'repair/stock/returned', { headers: this.header() })
      .then(res => this.setState({ returned: (res.data && res.data.data) || null }))
      .catch(() => toast.error("تعذّر تحميل الأجهزة المسحوبة"));
  };

  switchTab = (tab) => {
    this.setState({ tab });
    if (tab === "pending") this.loadPending();
    if (tab === "returned") this.loadReturned();
    if (tab === "stats") this.loadStats();
    if (tab === "pendingMac") this.loadPendingMac();
    if (tab === "verify") this.loadVerify();
    if (tab === "archive") this.loadArchive(1);
  };

  loadLists = () => {
    axios.get(host + 'repair/stock/lists', { headers: this.header() })
      .then(res => this.setState({ lists: (res.data && res.data.data && res.data.data.lists) || [] }))
      .catch(() => { });
  };

  // ===== سجل القوائم — مصفّح من الخادم =====
  // القوائم قد تكبر وأجهزتها بالعشرات (٥٠+): الخادم يعيد صفحة فقط
  // مع الإجماليات محسوبة بالتجميع — لا تحميل كامل في الواجهة أبداً.
  loadArchive = (page = 1) => {
    this.setState({ archiveLoading: true, archView: null });
    axios.get(host + `repair/stock/lists?page=${page}&limit=10`, { headers: this.header() })
      .then(res => this.setState({
        archiveLoading: false,
        archive: (res.data && res.data.data) || null,
      }))
      .catch(() => { this.setState({ archiveLoading: false }); toast.error("تعذّر تحميل السجل"); });
  };

  openArchiveList = (id, page = 1) => {
    this.setState({ archViewLoading: true });
    axios.get(host + `repair/stock/list?id=${id}&page=${page}&limit=25`, { headers: this.header() })
      .then(res => this.setState({
        archViewLoading: false,
        archView: (res.data && res.data.data) || null,
      }))
      .catch(() => { this.setState({ archViewLoading: false }); toast.error("تعذّر تحميل القائمة"); });
  };

  loadList = (id) => {
    this.setState({ loading: true });
    const qs = id ? `?id=${id}` : '';
    axios.get(host + 'repair/stock/list' + qs, { headers: this.header() })
      .then(res => {
        this.setState({ loading: false, data: (res.data && res.data.data) || null, viewingId: id || null });
        if (this.scanRef.current) this.scanRef.current.focus();
      })
      .catch(() => { this.setState({ loading: false }); toast.error("تعذّر تحميل القائمة"); });
  };

  // ===================== المسح =====================
  scan = () => {
    const v = (this.state.scanValue || "").trim();
    if (!v) return;

    this.setState({ working: true });
    axios.post(host + 'repair/stock/scan', { sn: v }, { headers: this.header() })
      .then(res => {
        this.setState({ working: false, scanValue: "" });
        const d = res.data && res.data.data;
        toast.success(`تمت الإضافة: ${d && d.composite_name ? d.composite_name : "الجهاز"}`);
        this.loadList();
        this.loadStats();
        if (this.scanRef.current) this.scanRef.current.focus();
      })
      .catch(err => {
        this.setState({ working: false, scanValue: "" });
        toast.error((err.response && err.response.data && err.response.data.message) || "فشل المسح");
        if (this.scanRef.current) this.scanRef.current.focus();
      });
  };

  pull = (device) => {
    const reason = window.prompt(
      `سحب الجهاز #${device.id} من القائمة وإرجاعه للصيانة.\n` +
      `سبب الرجوع (إلزامي) — سيظهر للفني عند ربط الجهاز:`
    );
    if (reason === null) return;
    if (!String(reason).trim()) {
      toast.error("يجب كتابة سبب الرجوع");
      return;
    }

    axios.put(host + 'repair/stock/pull',
      { device_id: device.id, reason: String(reason).trim(), returned_by_name: cookies.get("name") || "" },
      { headers: this.header() })
      .then(() => {
        toast.success("تم سحب الجهاز وإرجاعه للصيانة");
        this.loadList();
        this.loadStats();
        if (this.state.returned) this.loadReturned();
      })
      .catch(err => toast.error(
        (err.response && err.response.data && err.response.data.message) || "فشل السحب"));
  };

  closeList = () => {
    const d = this.state.data;
    if (!d || !d.list) return;
    if (!window.confirm(
      `قفل القائمة #${d.list.id} وإدخال ${d.count} جهاز للمخزن؟\n` +
      `سيتم تحديث العدد والسعر في المخزن بمعدّل التكلفة.`
    )) return;

    this.setState({ working: true });
    axios.put(host + `repair/stock/close/${d.list.id}`,
      {
        closed_by: cookies.get("name") || "",
        // ⚠️ التوكن في الجسم لا في الترويسة وحدها: النقطة بلا حارس
        // مصادقة، فـ GetAdmin لا يعمل فيها. وهذه أهم لحظة في سجل
        // الجهاز — من يقفل القائمة يصير المسؤول عن أجهزتها، وبلا
        // التوكن كان السجل يكتب «غير معروف» لأهم مرحلة.
        token: cookies.get("token"),
      }, { headers: this.header() })
      .then(res => {
        this.setState({ working: false });
        toast.success("تم قفل القائمة وإدخال الأجهزة للمخزن");
        const groups = res.data && res.data.data && res.data.data.groups;
        if (Array.isArray(groups)) {
          groups.forEach(g => toast.info(
            `${g.composite_name}: العدد ${g.count_before} ← ${g.count_after} · السعر ${fmt(g.avg_before)} ← ${fmt(g.avg_after)}`
          ));
        }
        this.loadList();
        this.loadLists();
        this.loadStats();
      })
      .catch(err => {
        this.setState({ working: false });
        toast.error((err.response && err.response.data && err.response.data.message) || "فشل القفل");
      });
  };

  // ===================== الطباعة =====================
  printSheet = (size) => {
    const d = this.state.data;
    if (!d || !d.devices || !d.devices.length) return toast.error("لا توجد أجهزة للطباعة");

    const rows = d.devices.map((x, i) => `
      <tr>
        <td>${i + 1}</td>
        <td><b>${x.composite_name || x.name}</b></td>
        <td>#${x.id}</td>
        <td>${(x.parts || []).map(p => `${p.part_name}×${p.qty}`).join("، ") || "—"}</td>
        <td>${x.employee || "—"}</td>
        <td>${x.transferred_at ? moment(x.transferred_at).format("YYYY/MM/DD HH:mm") : "—"}</td>
      </tr>`).join("");

    const summary = (d.summary || []).map(g => `
      <tr><td>${g.composite_name}</td><td>${g.count}</td></tr>`).join("");

    this.openPrint(size, `كشف قائمة التحويل #${d.list.id}`, `
      <table>
        <thead><tr>
          <th>#</th><th>الجهاز</th><th>الرقم</th>
          <th>قطع الغيار</th><th>الموظف</th><th>التاريخ</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>

      <h3>الملخّص حسب النوع</h3>
      <table class="sm">
        <thead><tr><th>الجهاز</th><th>العدد</th></tr></thead>
        <tbody>${summary}</tbody>
      </table>
      <p class="tot">الإجمالي: ${d.count} جهاز</p>
    `);
  };

  // ============================================================
  //  كشف قائمة من السجل — أي قائمة سابقة بأزرارها الخاصة
  //
  //  الطباعة تحتاج القائمة كاملة لا صفحة العرض (٢٥) — جلبة واحدة
  //  غير مصفّحة (الشكل القديم المتوافق) خاصة بالطباعة، ثم نفس قالب
  //  الكشف التفصيلي مع ترويسة القائمة (الحالة · أغلقها · الإجمالي).
  // ============================================================
  printArchiveSheet = (listId, size) => {
    axios.get(host + `repair/stock/list?id=${listId}`, { headers: this.header() })
      .then(res => {
        const d = (res.data && res.data.data) || null;
        if (!d || !d.devices || !d.devices.length) return toast.error("القائمة فارغة — لا شيء للطباعة");

        const meta = `
          <p style="margin:2px 0 12px;font-size:13px;color:#334155">
            الحالة: <b>${d.list.is_closed ? "مقفلة" : "مفتوحة"}</b>
            ${d.list.closed_by ? ` &nbsp;·&nbsp; أغلقها: <b>${d.list.closed_by}</b>` : ""}
            ${d.list.closed_at ? ` &nbsp;·&nbsp; بتاريخ: <b>${moment(d.list.closed_at).format("YYYY/MM/DD")}</b>` : ""}
            &nbsp;·&nbsp; عدد الأجهزة: <b>${d.count}</b>
            &nbsp;·&nbsp; الإجمالي: <b>${fmt(d.grandTotal)}</b>
          </p>`;

        const rows = d.devices.map((x, i) => `
          <tr>
            <td>${i + 1}</td>
            <td><b>${x.composite_name || x.name}</b></td>
            <td>#${x.id}</td>
            <td>${(x.parts || []).map(pp => `${pp.part_name}×${pp.qty}`).join("، ") || "—"}</td>
            <td>${x.employee || "—"}</td>
            <td>${x.transferred_at ? moment(x.transferred_at).format("YYYY/MM/DD HH:mm") : "—"}</td>
            <td>${fmt(x.total_cost)}</td>
          </tr>`).join("");

        const summary = (d.summary || []).map(g => `
          <tr><td>${g.composite_name}</td><td>${g.count}</td></tr>`).join("");

        this.openPrint(size, `كشف قائمة التحويل #${d.list.id}`, `
          ${meta}
          <table>
            <thead><tr>
              <th>#</th><th>الجهاز</th><th>الرقم</th>
              <th>قطع الغيار</th><th>الموظف</th><th>التاريخ</th><th>التكلفة</th>
            </tr></thead>
            <tbody>${rows}</tbody>
          </table>

          <h3>الملخّص حسب النوع</h3>
          <table class="sm">
            <thead><tr><th>الجهاز</th><th>العدد</th></tr></thead>
            <tbody>${summary}</tbody>
          </table>
          <p class="tot">إجمالي التكلفة: ${fmt(d.grandTotal)}</p>
        `);
      })
      .catch(() => toast.error("تعذّر جلب القائمة للطباعة"));
  };

  // كشف مختصر بعد القفل: اسم الجهاز والعدد
  printSummary = (size) => {
    const d = this.state.data;
    if (!d || !d.summary || !d.summary.length) return toast.error("لا يوجد ملخّص للطباعة");

    const rows = d.summary.map((g, i) => `
      <tr><td>${i + 1}</td><td><b>${g.composite_name}</b></td><td>${g.count}</td></tr>`).join("");

    this.openPrint(size, `كشف المخزن — قائمة #${d.list.id}`, `
      <table>
        <thead><tr><th>#</th><th>اسم الجهاز</th><th>العدد</th></tr></thead>
        <tbody>${rows}</tbody>
      </table>
      <p class="tot">إجمالي الأجهزة: ${d.count}</p>
    `);
  };

  openPrint = (size, title, body) => {
    const d = this.state.data;
    const w = window.open("", "_blank");
    if (!w) return toast.error("المتصفح منع فتح نافذة الطباعة");

    w.document.write(`
      <!DOCTYPE html><html lang="ar" dir="rtl"><head><meta charset="utf-8" />
      <title>${title}</title>
      <style>
        @page { size: ${size}; margin: 10mm; }
        body { font-family: "Segoe UI", Tahoma, sans-serif; direction: rtl; color: #111; padding: 6px; }
        h1 { font-size: 17px; margin: 0 0 4px; }
        h3 { font-size: 14px; margin: 16px 0 6px; }
        .meta { font-size: 11px; color: #555; margin-bottom: 12px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
        th, td { border: 1px solid #999; padding: 6px 7px; font-size: 11.5px; text-align: right; }
        th { background: #eee; font-weight: 700; }
        table.sm { width: 60%; }
        .tot { font-size: 13px; font-weight: 700; margin-top: 8px; }
        @media print { .noprint { display: none; } }
      </style></head><body>
        <h1>${title}</h1>
        <div class="meta">
          التاريخ: ${moment().format("YYYY/MM/DD HH:mm")}
          ${d && d.list && d.list.closed_by ? ` · أقفلها: ${d.list.closed_by}` : ""}
          ${d && d.list && d.list.is_closed ? " · (مقفلة)" : " · (مفتوحة)"}
        </div>
        ${body}
        <script>window.onload = function(){ window.print(); }<\/script>
      </body></html>`);
    w.document.close();
  };

  // ===================== قسم: إحصائيات الأجهزة =====================
  // غير الممسوحة / الممسوحة / المسحوبة — كل واحدة مفصّلة
  // ============================================================
  //  تبويب: بانتظار ربط الماك
  //  الطافيات أُدخلت يدوياً بالسيريال (wifi_mac = NULL). الماك يُربط
  //  من محطة الفحص بزر «مزامنة» بعد أن يشتغل الجهاز — لا يُربط من هنا،
  //  لأن الماك يجب أن يُقرأ من الجهاز نفسه لا أن يُكتب يدوياً.
  // ============================================================
  // ============================================================
  //  تبويب: تدقيق الإدخال — مطابقة الأقسام
  //  الغرض رقابي: كل ما خرج من الصيانة/السوفت/غير المعرّف (أنهاه
  //  الفني) يجب أن يصل ويُمسح لقائمة التحويل. المعلَّق هنا = منتهٍ
  //  وما زال بيد الفنيين. إنزاله من اللوحة يكون بمسحه في تبويب
  //  «قائمة التحويل» — لا مسح هنا: verify/scan ترفض المدقَّق مسبقاً
  //  وهذه الأجهزة دُقّقت كلها عند الإدخال.
  // ============================================================
  renderVerify() {
    const v = this.state.verify;
    if (!v) return this.Spinner();

    const stName = (x) => x === "sana" ? "صيانة" : x === "soft" ? "سوفت"
      : x === "ready" ? "جاهز للمخزن" : x === "stocked" ? "في المخزن" : x;

    return (
      <div>
        {/* مطابقة العدد — جوهر اللوحة */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
          <div style={{ ...S.stat, borderTop: "3px solid #0f172a" }}>
            <div style={S.statLabel}>خرجت من الأقسام</div>
            <div style={S.statValue}>{v.total}</div>
          </div>
          <div style={{ ...S.stat, borderTop: "3px solid #16a34a" }}>
            <div style={S.statLabel}>مُسحت للتحويل/المخزن</div>
            <div style={{ ...S.statValue, color: "#16a34a" }}>{v.verified_count}</div>
          </div>
          <div style={{ ...S.stat, borderTop: "3px solid #dc2626" }}>
            <div style={S.statLabel}>لم تُمسح بعد</div>
            <div style={{ ...S.statValue, color: "#dc2626" }}>{v.pending_count}</div>
            <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 4 }}>منتهية — لم تصل قائمة التحويل</div>
          </div>
        </div>

        <div style={v.matched ? S.okBox : S.warnBox}>
          {v.matched
            ? "✅ العدد مطابق — كل ما خرج من الأقسام مُسح لقائمة التحويل"
            : `⚠️ فرق ${v.pending_count} جهاز — خرجت من الأقسام ولم تُمسح لقائمة التحويل`}
        </div>

        <div style={{ ...S.card, ...S.pad, fontSize: 13, color: "#475569" }}>
          💡 لإنزال جهاز من هذه القائمة: امسح باركوده في تبويب <b>«قائمة التحويل»</b> —
          دخوله القائمة هو ما يطابق العدد هنا.
        </div>

        {/* المنتهية التي لم تُمسح */}
        <div style={S.card}>
          <div style={{ ...S.pad, paddingBottom: 0, fontSize: 15, fontWeight: 800, color: "#0f172a" }}>
            أجهزة خرجت من الأقسام ولم تُمسح ({v.pending_count})
          </div>
          {!v.pending.length
            ? <div style={S.empty}>✅ كل ما خرج من الأقسام مُسح لقائمة التحويل</div>
            : <div style={{ overflowX: "auto", padding: 8 }}>
              <table className="st-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={S.th}>#</th>
                    <th style={S.th}>الجهاز</th>
                    <th style={S.th}>السيريال</th>
                    <th style={S.th}>الأعطال</th>
                    <th style={S.th}>الحالة</th>
                    <th style={S.th}>المُدخِل</th>
                  </tr>
                </thead>
                <tbody>
                  {v.pending.map((d) => (
                    <tr key={d.device_id}>
                      <td style={S.td}><b>#{d.device_id}</b></td>
                      <td style={S.td}>{d.composite_name || d.name}</td>
                      <td style={{ ...S.td, fontFamily: "monospace", fontSize: 12.5 }}>{d.sn}</td>
                      <td style={S.td}>
                        {d.faults && d.faults.length
                          ? d.faults.map((f, i) => (
                            <span key={i} style={{ ...S.chip, background: "#fef3c7", color: "#92400e", borderColor: "#fde68a" }}>{f}</span>
                          ))
                          : <span style={{ color: "#cbd5e1" }}>—</span>}
                      </td>
                      <td style={S.td}>
                        <span style={S.badge("#fee2e2", "#991b1b")}>{stName(d.status)}</span>
                      </td>
                      <td style={{ ...S.td, color: "#64748b" }}>{d.added_by_name || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>}
        </div>
      </div>
    );
  }

  renderPendingMac() {
    const pm = this.state.pendingMac;
    if (!pm) return this.Spinner();

    const rows = pm.results || [];
    const stName = (s) => s === "sana" ? "صيانة"
      : s === "soft" ? "سوفت"
        : s === "ready" ? "جاهز للمخزن"
          : s === "stocked" ? "في المخزن" : s;
    const stColor = (s) => s === "sana" ? ["#fef3c7", "#92400e"]
      : s === "soft" ? ["#ede9fe", "#5b21b6"]
        : s === "ready" ? ["#dcfce7", "#166534"] : ["#f1f5f9", "#475569"];

    return (
      <div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
          <div style={{ ...S.stat, borderTop: "3px solid #3b82f6" }}>
            <div style={S.statLabel}>بانتظار ربط الماك</div>
            <div style={{ ...S.statValue, color: "#3b82f6" }}>{rows.length}</div>
            <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 4 }}>
              أجهزة طافية بلا هوية ثابتة
            </div>
          </div>
        </div>

        <div style={{ ...S.warnBox, background: "#eff6ff", borderColor: "#bfdbfe", color: "#1e40af" }}>
          ℹ️ هذه الأجهزة أُدخلت يدوياً بالسيريال ولم يُقرأ منها الماك بعد.
          بعد تشغيل الجهاز، اربطه بالكيبل في محطة الفحص واضغط «🔄 مزامنة» ليُربط الماك تلقائياً.
          الربط لا يتم من لوحة التحكم لأن الماك يجب أن يُقرأ من الجهاز نفسه.
        </div>

        <div style={S.card}>
          {!rows.length
            ? <div style={S.empty}>✅ لا توجد أجهزة بانتظار الماك — كل الأجهزة لها هوية ثابتة</div>
            : <div style={{ overflowX: "auto" }}>
              <table className="st-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={S.th}>#</th>
                    <th style={S.th}>الجهاز</th>
                    <th style={S.th}>السيريال</th>
                    <th style={S.th}>الحالة</th>
                    <th style={S.th}>أُدخل بواسطة</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((d) => {
                    const [bg, col] = stColor(d.status);
                    return (
                      <tr key={d.id}>
                        <td style={S.td}><b>#{d.id}</b></td>
                        <td style={S.td}>{d.composite_name || d.name}</td>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: 12.5 }}>
                          {d.sn || "—"}
                        </td>
                        <td style={S.td}>
                          <span style={S.badge(bg, col)}>{stName(d.status)}</span>
                        </td>
                        <td style={{ ...S.td, color: "#64748b" }}>{d.added_by_name || "—"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>}
        </div>
      </div>
    );
  }


  // ============================================================
  //  سجل القوائم السابقة — مصفّح من الخادم
  // ============================================================
  Spinner = (msg) => (
    <div style={{ ...S.card, ...S.spinWrap }}>
      <div style={S.spinner} /> {msg || "جاري التحميل…"}
    </div>
  );

  Pager = ({ page, pages, busy, go }) => {
    if (!pages || pages <= 1) return null;
    const first = page === 1 || busy, last = page === pages || busy;
    return (
      <div style={S.pager}>
        <button style={S.pBtn(first)} disabled={first} onClick={() => go(1)}>»</button>
        <button style={S.pBtn(first)} disabled={first} onClick={() => go(page - 1)}>السابق</button>
        <span style={S.pInfo}>صفحة {page} من {pages}</span>
        <button style={S.pBtn(last)} disabled={last} onClick={() => go(page + 1)}>التالي</button>
        <button style={S.pBtn(last)} disabled={last} onClick={() => go(pages)}>«</button>
      </div>
    );
  };

  renderArchive() {
    const { archive, archiveLoading, archView, archViewLoading } = this.state;

    // استعراض قائمة واحدة (أجهزتها مصفّحة ٢٥/صفحة)
    if (archView || archViewLoading) {
      if (archViewLoading && !archView) return this.Spinner("جاري تحميل القائمة…");
      const v = archView;
      const closed = v.list && v.list.is_closed;
      return (
        <>
          <div style={{ ...S.card, ...S.pad, display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
            <button style={S.pBtn(false)} onClick={() => this.setState({ archView: null })}>◀ رجوع للسجل</button>
            <b style={{ fontSize: 17 }}>القائمة #{v.list.id}</b>
            <span style={{
              padding: "3px 12px", borderRadius: 12, fontSize: 12.5, fontWeight: 800,
              background: closed ? "#dcfce7" : "#fef9c3", color: closed ? "#166534" : "#854d0e",
            }}>{closed ? "مقفلة" : "مفتوحة"}</span>
            <span style={{ color: "#64748b", fontSize: 13.5 }}>
              {v.count} جهازاً · الإجمالي <b style={{ color: "#16a34a" }}>{v.grandTotal}</b>
              {v.list.closed_by ? ` · أغلقها ${v.list.closed_by}` : ""}
            </span>
            <span style={{ marginInlineStart: "auto", display: "flex", gap: 8 }}>
              <button className="st-btn" style={S.btnGhost}
                onClick={() => this.printArchiveSheet(v.list.id, "A4")}>🖨️ كشف A4</button>
              <button className="st-btn" style={S.btnGhost}
                onClick={() => this.printArchiveSheet(v.list.id, "A5")}>🖨️ كشف A5</button>
            </span>
          </div>

          {archViewLoading ? this.Spinner() : (
            <div style={S.card}>
              <table className="st-table" style={S.table}>
                <thead><tr>
                  <th style={S.th}>#</th><th style={S.th}>اسم الجهاز</th>
                  <th style={S.th}>الرقم</th><th style={S.th}>قطع الغيار</th>
                  <th style={S.th}>الموظف</th><th style={S.th}>تاريخ التحويل</th>
                  <th style={S.th}>التكلفة</th>
                </tr></thead>
                <tbody>
                  {v.devices.map((d, i) => (
                    <tr key={d.id}>
                      <td style={S.td}>{(v.page - 1) * v.limit + i + 1}</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{d.composite_name}</td>
                      <td style={S.td}>#{d.id}</td>
                      <td style={S.td}>{(d.parts || []).map(p => `${p.part_name}×${p.qty}`).join("، ") || "—"}</td>
                      <td style={S.td}>{d.employee || "—"}</td>
                      <td style={S.td}>{d.transferred_at ? String(d.transferred_at).slice(0, 10) : "—"}</td>
                      <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{d.total_cost}</td>
                    </tr>
                  ))}
                  {!v.devices.length && (
                    <tr><td colSpan={7} style={{ ...S.td, ...S.empty }}>القائمة فارغة</td></tr>
                  )}
                </tbody>
              </table>
              <this.Pager page={v.page} pages={v.pages} busy={archViewLoading}
                go={(p) => this.openArchiveList(v.list.id, p)} />
            </div>
          )}
        </>
      );
    }

    // جدول السجل
    if (archiveLoading && !archive) return this.Spinner("جاري تحميل السجل…");
    if (!archive) return <div style={{ ...S.card, ...S.empty }}>لا يوجد سجل</div>;
    return (
      <>
        <div style={S.card}>
          <table className="st-table" style={S.table}>
            <thead><tr>
              <th style={S.th}>القائمة</th><th style={S.th}>الحالة</th>
              <th style={S.th}>عدد الأجهزة</th><th style={S.th}>إجمالي التكلفة</th>
              <th style={S.th}>أغلقها</th><th style={S.th}>تاريخ الإغلاق</th>
              <th style={S.th}></th>
            </tr></thead>
            <tbody>
              {archive.rows.map(r => (
                <tr key={r.id}>
                  <td style={{ ...S.td, fontWeight: 800 }}>#{r.id}</td>
                  <td style={S.td}>
                    <span style={{
                      padding: "2px 11px", borderRadius: 11, fontSize: 12, fontWeight: 800,
                      background: r.is_closed ? "#dcfce7" : "#fef9c3",
                      color: r.is_closed ? "#166534" : "#854d0e",
                    }}>{r.is_closed ? "مقفلة" : "مفتوحة"}</span>
                  </td>
                  <td style={S.td}>{r.device_count}</td>
                  <td style={{ ...S.td, fontWeight: 800, color: "#16a34a" }}>{r.total_cost}</td>
                  <td style={S.td}>{r.closed_by || "—"}</td>
                  <td style={S.td}>{r.closed_at ? String(r.closed_at).slice(0, 10) : "—"}</td>
                  <td style={{ ...S.td, whiteSpace: "nowrap" }}>
                    <button className="st-btn" style={{ ...S.pBtn(false), background: "#2563eb", color: "#fff", border: "none", marginInlineEnd: 6 }}
                      onClick={() => this.openArchiveList(r.id, 1)}>استعراض</button>
                    <button className="st-btn" style={S.pBtn(false)} title="طباعة كشف تفصيلي A4"
                      onClick={() => this.printArchiveSheet(r.id, "A4")}>🖨️</button>
                  </td>
                </tr>
              ))}
              {!archive.rows.length && (
                <tr><td colSpan={7} style={{ ...S.td, ...S.empty }}>لا توجد قوائم بعد</td></tr>
              )}
            </tbody>
          </table>
          <this.Pager page={archive.page} pages={archive.pages} busy={archiveLoading}
            go={(p) => this.loadArchive(p)} />
        </div>
      </>
    );
  }

  renderStats() {
    const st = this.state.stats;
    if (!st) return this.Spinner();

    const bigCard = (label, value, color, sub) => (
      <div style={{ ...S.stat, borderTop: `3px solid ${color}` }}>
        <div style={S.statLabel}>{label}</div>
        <div style={{ ...S.statValue, color }}>{value}</div>
        {sub ? <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 4 }}>{sub}</div> : null}
      </div>
    );

    // جدول توزيع بالنوع
    const dist = (rows, emptyMsg) => (
      !rows || !rows.length
        ? <div style={{ fontSize: 13, color: "#cbd5e1", padding: "8px 0" }}>{emptyMsg}</div>
        : <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
          {rows.map((g, i) => (
            <div key={i} style={{
              padding: "7px 13px", borderRadius: 9, background: "#f8fafc",
              border: "1px solid #eef2f7", fontSize: 12.5,
            }}>
              <span style={{ color: "#334155" }}>{g.name}</span>
              <b style={{ marginInlineStart: 7, color: "#2563eb" }}>{g.count}</b>
            </div>
          ))}
        </div>
    );

    const groupBlock = (g) => (
      <div key={g.key} style={{
        padding: "14px 16px", borderRadius: 12,
        background: "#fff", border: "1px solid #eef2f7", marginBottom: 10,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>{g.label}</div>
          <div style={{
            marginInlineStart: "auto", fontSize: 19, fontWeight: 800,
            color: g.count > 0 ? "#2563eb" : "#cbd5e1",
          }}>{g.count}</div>
        </div>
        {g.count > 0 ? dist(g.by_device, "—") : null}
      </div>
    );

    return (
      <>
        <div style={{ display: "flex", gap: 14, marginBottom: 20, flexWrap: "wrap" }}>
          {bigCard("غير الممسوحة", st.unscanned.total, "#d97706", "خرجت من الأقسام ولم تدخل قائمة تحويل")}
          {bigCard("الممسوحة", st.scanned.total, "#16a34a", "في قائمة أو دخلت المخزن")}
          {bigCard("المسحوبة", st.returned.total, "#dc2626", "رجعت من لوحة التحكم")}
          {bigCard("إجمالي الأجهزة", st.grand_total, "#0f172a", "كل ما خرج من الأقسام")}
          {st.pending_mac
            ? bigCard("بانتظار الماك", st.pending_mac.total, "#3b82f6", "طافيات بلا هوية ثابتة — كل الأقسام")
            : null}
        </div>

        {/* ===== بانتظار ربط الماك ===== */}
        {st.pending_mac && st.pending_mac.total > 0 ? (
          <div style={{ ...S.card, ...S.pad }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
              <b style={{ fontSize: 15, color: "#0f172a" }}>بانتظار ربط الماك</b>
              <span style={{ ...S.badge("#dbeafe", "#1d4ed8"), marginInlineStart: 10 }}>
                {st.pending_mac.total} جهاز
              </span>
            </div>
            <div style={{ fontSize: 12.5, color: "#64748b", marginBottom: 4 }}>بالنوع</div>
            {dist(st.pending_mac.by_device, "—")}
            <div style={{ fontSize: 12.5, color: "#64748b", margin: "14px 0 4px" }}>بالقسم</div>
            {dist(st.pending_mac.by_status, "—")}
          </div>
        ) : null}

        {/* ===== غير الممسوحة ===== */}
        <div style={{ ...S.card, ...S.pad }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
              الأجهزة غير الممسوحة
            </div>
            <div style={{ marginInlineStart: "auto", ...S.badge("#fffbeb", "#d97706") }}>
              {st.unscanned.total} جهاز
            </div>
          </div>
          {st.unscanned.groups.map(groupBlock)}
        </div>

        {/* ===== الممسوحة ===== */}
        <div style={{ ...S.card, ...S.pad }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
              الأجهزة الممسوحة
            </div>
            <div style={{ marginInlineStart: "auto", ...S.badge("#f0fdf4", "#16a34a") }}>
              {st.scanned.total} جهاز
            </div>
          </div>
          {st.scanned.groups.map(groupBlock)}
        </div>

        {/* ===== المسحوبة ===== */}
        <div style={{ ...S.card, ...S.pad }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
              الأجهزة المسحوبة
            </div>
            <div style={{ marginInlineStart: "auto", ...S.badge("#fef2f2", "#dc2626") }}>
              {st.returned.total} جهاز
            </div>
          </div>

          {st.returned.total === 0
            ? <div style={{ fontSize: 13.5, color: "#94a3b8" }}>لا توجد أجهزة مسحوبة</div>
            : <>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#475569", marginBottom: 4 }}>
                حسب نوع الجهاز
              </div>
              {dist(st.returned.by_device, "—")}

              <div style={{ fontSize: 13, fontWeight: 700, color: "#475569", margin: "16px 0 4px" }}>
                حسب سبب الرجوع
              </div>
              {dist(st.returned.by_reason, "—")}

              <div style={{ fontSize: 13, fontWeight: 700, color: "#475569", margin: "18px 0 8px" }}>
                آخر الأجهزة المسحوبة
              </div>
              <div style={{ overflowX: "auto" }}>
              <table className="st-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ ...S.th, width: 70 }}>الرقم</th>
                    <th style={S.th}>الجهاز</th>
                    <th style={{ ...S.th, width: 95 }}>الحالة</th>
                    <th style={S.th}>السبب</th>
                    <th style={{ ...S.th, width: 110 }}>سحبه</th>
                    <th style={{ ...S.th, width: 140 }}>التاريخ</th>
                  </tr>
                </thead>
                <tbody>
                  {st.returned.devices.map((d) => (
                    <tr key={d.id}>
                      <td style={{ ...S.td, fontWeight: 700 }}>#{d.id}</td>
                      <td style={S.td}>
                        <b>{d.name}</b>
                        {d.return_count > 1 ? (
                          <span style={{ ...S.chip, background: "#fef2f2", color: "#dc2626", borderColor: "#fecaca", marginInlineStart: 6 }}>
                            {d.return_count}×
                          </span>
                        ) : null}
                      </td>
                      <td style={S.td}>
                        <span style={S.badge(
                          d.status === "sana" ? "#fffbeb" : d.status === "soft" ? "#eff6ff" : "#f0fdf4",
                          d.status === "sana" ? "#d97706" : d.status === "soft" ? "#2563eb" : "#16a34a")}>
                          {d.status_label}
                        </span>
                      </td>
                      <td style={{ ...S.td, color: "#b45309", fontWeight: 600 }}>
                        {d.return_reason || "—"}
                      </td>
                      <td style={S.td}>{d.returned_by_name || "—"}</td>
                      <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>
                        {d.returned_at ? moment(d.returned_at).format("YYYY/MM/DD HH:mm") : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </>}
        </div>
      </>
    );
  }

  // ===================== قسم: أجهزة جاهزة للمخزن =====================
  // الأجهزة المضافة للقائمة المفتوحة والتي تنتظر موافقة القفل
  renderPending() {
    const p = this.state.pending;
    if (!p) return this.Spinner();

    const devices = p.devices || [];
    const summary = p.summary || [];
    const sumCount = summary.reduce((a, g) => a + g.count, 0);
    const matches = sumCount === p.count;

    return (
      <>
        <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
          <div style={S.stat}>
            <div style={S.statLabel}>القائمة</div>
            <div style={S.statValue}>{p.list ? `#${p.list.id}` : "—"}</div>
          </div>
          <div style={S.stat}>
            <div style={S.statLabel}>إجمالي الأجهزة</div>
            <div style={{ ...S.statValue, color: "#2563eb" }}>{p.count}</div>
          </div>
          <div style={S.stat}>
            <div style={S.statLabel}>مجموع الأنواع</div>
            <div style={{ ...S.statValue, color: matches ? "#16a34a" : "#dc2626" }}>{sumCount}</div>
          </div>
        </div>

        <div style={matches ? S.okBox : S.warnBox}>
          {matches
            ? `✓ العدد مطابق: ${p.count} جهاز موزّعة على ${summary.length} نوع`
            : `⚠ عدم تطابق: الإجمالي ${p.count} ومجموع الأنواع ${sumCount}`}
        </div>

        <div style={{ ...S.card, ...S.pad }}>
          <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 13 }}>العدد لكل نوع</div>
          {!summary.length && <div style={{ color: "#94a3b8", fontSize: 14 }}>لا توجد أجهزة</div>}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            {summary.map((g, i) => (
              <div key={i} style={S.sumCard}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>{g.composite_name}</div>
                <div style={{ fontSize: 26, fontWeight: 800, color: "#2563eb" }}>{g.count}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <div style={{ overflowX: "auto" }}>
          <table className="st-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ ...S.th, width: 45 }}>#</th>
                <th style={S.th}>اسم الجهاز</th>
                <th style={{ ...S.th, width: 80 }}>الرقم</th>
                <th style={{ ...S.th, width: 130 }}>السيريال</th>
                <th style={{ ...S.th, width: 130 }}>الماك (الهوية)</th>
                <th style={{ ...S.th, width: 120 }}>الموظف</th>
                <th style={{ ...S.th, width: 145 }}>تاريخ الإضافة</th>
              </tr>
            </thead>
            <tbody>
              {!devices.length && (
                <tr><td colSpan={7} style={S.empty}>لا توجد أجهزة تنتظر الموافقة</td></tr>
              )}
              {devices.map((x, i) => (
                <tr key={x.id}>
                  <td style={S.td}>{i + 1}</td>
                  <td style={S.td}>
                    <b>{x.composite_name || x.name}</b>
                    {x.was_returned ? (
                      <span style={{ ...S.chip, background: "#fffbeb", color: "#b45309", borderColor: "#fde68a", marginInlineStart: 6 }}>
                        رجع {x.return_count > 1 ? `${x.return_count}×` : ""}
                      </span>
                    ) : null}
                  </td>
                  <td style={{ ...S.td, fontWeight: 700 }}>#{x.id}</td>
                  <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>{x.sn}</td>
                  <td style={{ ...S.td, fontSize: 12, fontFamily: "monospace", color: "#334155" }}>
                    {x.wifi_mac
                      ? x.wifi_mac
                      : <span style={S.badge("#dbeafe", "#1d4ed8")}>بانتظار الماك</span>}
                  </td>
                  <td style={S.td}>{x.employee || "—"}</td>
                  <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>
                    {x.transferred_at ? moment(x.transferred_at).format("YYYY/MM/DD HH:mm") : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </>
    );
  }

  // ===================== قسم: الأجهزة المسحوبة =====================
  // الأجهزة التي راحت للوحة التحكم ورجعت مع سبب الرجوع
  renderReturned() {
    const r = this.state.returned;
    if (!r) return this.Spinner();

    const devices = r.devices || [];
    const summary = r.summary || [];

    return (
      <>
        <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
          <div style={S.stat}>
            <div style={S.statLabel}>إجمالي المسحوبة</div>
            <div style={{ ...S.statValue, color: "#d97706" }}>{r.count}</div>
          </div>
          {summary.slice(0, 3).map((g, i) => (
            <div key={i} style={S.stat}>
              <div style={S.statLabel}>{g.name}</div>
              <div style={S.statValue}>{g.count}</div>
            </div>
          ))}
        </div>

        <div style={S.card}>
          <div style={{ overflowX: "auto" }}>
          <table className="st-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ ...S.th, width: 45 }}>#</th>
                <th style={S.th}>اسم الجهاز</th>
                <th style={{ ...S.th, width: 80 }}>الرقم</th>
                <th style={{ ...S.th, width: 95 }}>الحالة</th>
                <th style={S.th}>سبب الرجوع</th>
                <th style={{ ...S.th, width: 115 }}>سحبه</th>
                <th style={{ ...S.th, width: 145 }}>تاريخ الرجوع</th>
              </tr>
            </thead>
            <tbody>
              {!devices.length && (
                <tr><td colSpan={7} style={S.empty}>لا توجد أجهزة مسحوبة</td></tr>
              )}
              {devices.map((x, i) => (
                <tr key={x.id}>
                  <td style={S.td}>{i + 1}</td>
                  <td style={S.td}>
                    <b>{x.base_name}</b>
                    <div style={{ fontSize: 12, color: "#94a3b8" }}>{x.composite_name}</div>
                  </td>
                  <td style={{ ...S.td, fontWeight: 700 }}>#{x.id}</td>
                  <td style={S.td}>
                    <span style={S.badge(
                      x.status === "sana" ? "#fffbeb" : x.status === "soft" ? "#eff6ff" : "#f0fdf4",
                      x.status === "sana" ? "#d97706" : x.status === "soft" ? "#2563eb" : "#16a34a")}>
                      {x.status_label}
                    </span>
                    {x.return_count > 1 ? (
                      <div style={{ fontSize: 11.5, color: "#dc2626", marginTop: 4, fontWeight: 700 }}>
                        رجع {x.return_count} مرات
                      </div>
                    ) : null}
                  </td>
                  <td style={{ ...S.td, color: "#b45309", fontWeight: 600 }}>
                    {x.return_reason || "—"}
                  </td>
                  <td style={S.td}>{x.returned_by_name || "—"}</td>
                  <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>
                    {x.returned_at ? moment(x.returned_at).format("YYYY/MM/DD HH:mm") : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { data, loading, scanValue, working, lists, viewingId, tab, stats } = this.state;
    const list = data && data.list;
    const devices = (data && data.devices) || [];
    const summary = (data && data.summary) || [];
    const closed = list && list.is_closed;

    return (
      <div style={{ ...S.page, ...S.pageInner }}>
        <style>{stCss}</style>
        <ToastContainer position="bottom-left" autoClose={4500} rtl />

        {/* ===== الهيدر البطولي: العنوان + مؤشرات القائمة الحالية ===== */}
        <div style={S.hero}>
          <div>
            <h1 style={S.heroTitle}>📦 التحويل للمخزن</h1>
            <p style={S.heroSub}>
              امسح باركود الجهاز الجاهز (أو أدخل رقمه) لإضافته للقائمة —
              وعند القفل تُحدَّث أعداد وأسعار المخزن بمعدّل التكلفة.
            </p>
          </div>
          <div style={S.heroStats}>
            <div style={S.heroStat}>
              <div style={S.heroStatLabel}>القائمة</div>
              <div style={S.heroStatValue}>
                #{list ? list.id : "…"}{" "}
                <span style={{ fontSize: 11.5, fontWeight: 700, opacity: .85 }}>
                  {closed ? "مقفلة" : "مفتوحة"}
                </span>
              </div>
            </div>
            <div style={S.heroStat}>
              <div style={S.heroStatLabel}>عدد الأجهزة</div>
              <div style={S.heroStatValue}>{data ? data.count : 0}</div>
            </div>
            <div style={S.heroStat}>
              <div style={S.heroStatLabel}>إجمالي التكلفة</div>
              <div style={{ ...S.heroStatValue, color: "#86efac" }}>{data ? fmt(data.grandTotal) : 0}</div>
            </div>
          </div>
        </div>

        <div style={S.tabs}>
          <div style={S.tab(tab === "list")} onClick={() => this.switchTab("list")}>
            قائمة التحويل
          </div>
          <div style={S.tab(tab === "pending")} onClick={() => this.switchTab("pending")}>
            أجهزة جاهزة للمخزن
          </div>
          <div style={S.tab(tab === "returned")} onClick={() => this.switchTab("returned")}>
            الأجهزة المسحوبة
          </div>
          <div style={S.tab(tab === "verify")} onClick={() => this.switchTab("verify")}>
            تدقيق الإدخال
            {stats && stats.pending_verify > 0 ? (
              <span style={{
                marginInlineStart: 7, padding: "1px 8px", borderRadius: 10, fontSize: 11.5,
                background: tab === "verify" ? "rgba(255,255,255,.25)" : "#fee2e2",
                color: tab === "verify" ? "#fff" : "#991b1b",
              }}>{stats.pending_verify}</span>
            ) : null}
          </div>
          <div style={S.tab(tab === "pendingMac")} onClick={() => this.switchTab("pendingMac")}>
            بانتظار ربط الماك
            {stats && stats.pending_mac && stats.pending_mac.total > 0 ? (
              <span style={{
                marginInlineStart: 7, padding: "1px 8px", borderRadius: 10, fontSize: 11.5,
                background: tab === "pendingMac" ? "rgba(255,255,255,.25)" : "#dbeafe",
                color: tab === "pendingMac" ? "#fff" : "#1d4ed8",
              }}>{stats.pending_mac.total}</span>
            ) : null}
          </div>
          <div style={S.tab(tab === "archive")} onClick={() => this.switchTab("archive")}>
            سجل القوائم
          </div>
          <div style={S.tab(tab === "stats")} onClick={() => this.switchTab("stats")}>
            الإحصائيات
          </div>
        </div>

        {tab === "archive" && this.renderArchive()}
        {tab === "stats" && this.renderStats()}
        {tab === "pendingMac" && this.renderPendingMac()}
        {tab === "verify" && this.renderVerify()}
        {tab === "pending" && this.renderPending()}
        {tab === "returned" && this.renderReturned()}
        {tab === "list" && <>

        {/* شريط المسح */}
        {!closed && (
          <div style={{ ...S.card, ...S.pad, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <span style={{ fontSize: 22 }}>🔍</span>
            <input
              ref={this.scanRef}
              autoFocus
              className="st-scan"
              style={{ ...S.input, flex: 1, minWidth: 260 }}
              placeholder="امسح الباركود أو أدخل رقم الجهاز…"
              value={scanValue}
              onChange={e => this.setState({ scanValue: e.target.value })}
              onKeyDown={e => { if (e.key === "Enter") this.scan(); }}
            />
            <button className="st-btn" style={{ ...S.btnPrimary, opacity: working ? .6 : 1 }}
              disabled={working} onClick={this.scan}>＋ إضافة</button>
          </div>
        )}

        {/* مطابقة العدد الكلي مع مجموع الأنواع */}
        {summary.length > 0 && (() => {
          const sumCount = summary.reduce((a, g) => a + g.count, 0);
          const ok = sumCount === (data ? data.count : 0);
          return (
            <div style={ok ? S.okBox : S.warnBox}>
              {ok
                ? `✓ العدد مطابق: ${data.count} جهاز ممسوح = مجموع الأنواع ${sumCount}`
                : `⚠ عدم تطابق: الممسوح ${data.count} ومجموع الأنواع ${sumCount}`}
            </div>
          );
        })()}

        {/* الملخّص حسب النوع */}
        {summary.length > 0 && (
          <div style={{ ...S.card, ...S.pad }}>
            <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 13 }}>العدد حسب النوع</div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {summary.map((g, i) => (
                <div key={i} style={S.sumCard}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 5 }}>
                    {g.composite_name}
                  </div>
                  <div style={{ display: "flex", gap: 14 }}>
                    <div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>العدد</div>
                      <div style={{ fontSize: 19, fontWeight: 800, color: "#2563eb" }}>{g.count}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>معدّل التكلفة</div>
                      <div style={{ fontSize: 19, fontWeight: 800 }}>{fmt(g.avg_cost)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* أزرار العمليات */}
        <div style={{ ...S.card, ...S.pad, display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <button style={S.btnGhost} onClick={() => this.printSheet("A4")}>🖨️ كشف تفصيلي A4</button>
          <button style={S.btnGhost} onClick={() => this.printSheet("A5")}>🖨️ كشف تفصيلي A5</button>
          <button style={S.btnGhost} onClick={() => this.printSummary("A5")}>🖨️ كشف المخزن (اسم/عدد)</button>
          <div style={{ marginInlineStart: "auto", display: "flex", gap: 10 }}>
            <select style={{ ...S.input, padding: "9px 12px", fontSize: 13.5 }}
              value={viewingId || ""}
              onChange={e => this.loadList(e.target.value ? Number(e.target.value) : undefined)}>
              <option value="">القائمة المفتوحة</option>
              {lists.filter(l => l.is_closed).map(l => (
                <option key={l.id} value={l.id}>
                  #{l.id} — {l.title} ({l.devices_count})
                </option>
              ))}
            </select>
            {!closed && devices.length > 0 && (
              <button style={{ ...S.btnOk, opacity: working ? .6 : 1 }}
                disabled={working} onClick={this.closeList}>
                🔒 قفل القائمة وإدخال المخزن
              </button>
            )}
          </div>
        </div>

        {/* جدول الأجهزة */}
        <div style={S.card}>
          {loading && <div style={S.spinWrap}><div style={S.spinner} /> جاري التحميل…</div>}
          {!loading && (
            <div style={{ overflowX: "auto" }}>
            <table className="st-table" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ ...S.th, width: 45 }}>#</th>
                  <th style={S.th}>اسم الجهاز</th>
                  <th style={{ ...S.th, width: 75 }}>الرقم</th>
                  <th style={S.th}>قطع الغيار</th>
                  <th style={{ ...S.th, width: 110 }}>الموظف</th>
                  <th style={{ ...S.th, width: 135 }}>تاريخ التحويل</th>
                  <th style={{ ...S.th, width: 105 }}>التكلفة</th>
                  {!closed && <th style={{ ...S.th, width: 70 }}></th>}
                </tr>
              </thead>
              <tbody>
                {!devices.length && (
                  <tr><td colSpan={closed ? 7 : 8} style={S.empty}>
                    لا توجد أجهزة في القائمة — امسح باركود جهاز جاهز
                  </td></tr>
                )}
                {devices.map((x, i) => (
                  <tr key={x.id}>
                    <td style={S.td}>{i + 1}</td>
                    <td style={S.td}>
                      <b>{x.composite_name || x.name}</b>
                      {x.is_bypass ? <span style={{ ...S.chip, marginInlineStart: 6 }}>BayPass</span> : null}
                    </td>
                    <td style={{ ...S.td, fontWeight: 700 }}>#{x.id}</td>
                    <td style={S.td}>
                      {(x.parts || []).length
                        ? x.parts.map((p, k) => (
                          <span key={k} style={S.chip}>{p.part_name} ×{p.qty}</span>
                        ))
                        : <span style={{ color: "#cbd5e1" }}>—</span>}
                    </td>
                    <td style={S.td}>{x.employee || "—"}</td>
                    <td style={{ ...S.td, fontSize: 12.5, color: "#64748b" }}>
                      {x.transferred_at ? moment(x.transferred_at).format("YYYY/MM/DD HH:mm") : "—"}
                    </td>
                    <td style={{ ...S.td, fontWeight: 700 }}>{fmt(x.total_cost)}</td>
                    {!closed && (
                      <td style={S.td}>
                        <button style={S.btnDanger} onClick={() => this.pull(x)}>سحب</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
        </>}
      </div>
    );
  }
}
